import React from 'react';

const ToggleSwitch = ({ id, checked, onChange, label, disabled }) => {
    return (
        <div className={`toggle-switch-container ${disabled ? 'disabled' : ''}`}>
            <label className={`toggle-switch ${disabled ? 'disabled' : ''}`} htmlFor={id}>
                <input
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                />
                <span className="toggle-slider round"></span>
            </label>
            {label && <span className="toggle-label" onClick={() => document.getElementById(id).click()}>{label}</span>}
        </div>
    );
};

export default ToggleSwitch;
